export default __webpack_public_path__ + "static/media/institutions.bc45e09c.md";